import React, { useState } from "react";
import { Box, Typography, Collapse, Button, Grid } from "@mui/material";
import MyCalendar from "./istqb/ReactCalendar";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import purplePlus from "../../assets/purple_plus.svg";
import purpleMinus from "../../assets/purple_minus.svg";
import {fontType} from "../../constants/font";
import {courses} from "../../data/courses";

const Calendar = ({ handleFormOpen, isSelectedDate, setContactForm, setContactMessage, courseData }) => {
  const formatDate = (data) => {
    const date = new Date(data); // The Date object you want to convert
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("sk-SK", options);
    return formattedDate;
  };
  const [isOpen, setIsOpen] = useState(true);

  const course = courses.find((obj) => obj.code === courseData?.code);

  const onButtonClick = (date) => {
    isSelectedDate(date);
    handleFormOpen();
  };

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });
  const [products, inViewProducts] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });
  const [third, inViewThird] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });

  const openForm = () => {
    setContactForm(true);
    setContactMessage(
        course?.code !== 'internship'
        ? `Potrebujem poradiť ohľadom kurzu ${courseData?.name} v cene ${courseData?.price ? courseData.price + "€" : ""}`
        : "Potrebujem poradiť ohľadom praktickej stáže"
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <motion.div
        ref={products}
        initial={{ opacity: 0, y: 50 }}
        animate={inViewProducts ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.7 }}
      >
        {course?.code !== 'internship' ? (
          <Box
            sx={{
              backgroundColor: "#eba62c",
              height: "100px",
              display: "flex",
              justifyContent: "center",
              borderColor: "white",
            }}
          >
            <Box
              sx={{
                maxWidth: "1440px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ marginLeft: "9vw" }}>
                <Typography
                  sx={{
                    color: "white",
                    fontFamily: fontType.semiBold,
                    fontSize: "22px",
                    lineHeight: "26px",
                  }}
                >
                  Vyber si voľný termín školenia
                </Typography>
              </Box>
              <Box
                sx={{
                  marginRight: { md: "9vw", xs: "20px" },
                  width: "186px",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <img src={isOpen ? purpleMinus : purplePlus} alt="calendar_collapse" style={{ cursor: "pointer" }} onClick={toggleCollapse} />
              </Box>
            </Box>
          </Box>
        ) : null}
        <Collapse in={isOpen} timeout={300} unmountOnExit>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              borderTop: "2px solid",
              borderColor: "white",
              justifyContent: "center",
              backgroundColor: "#eba62c",
              alignItems: { md: "unset", xs: "center" },
              gap: "20px",
              paddingTop: "50px",
              paddingBottom: "50px",
              flexDirection: { md: "row", xs: "column" },
            }}
          >
            <Grid
              container
              sx={{
                gap: "10px",
                maxWidth: "500px",
                display: "flex",
                justifyContent: { md: "unset", xs: "center" },
              }}
            >
              {courseData?.terms && courseData.terms.length > 0 ? (
                  courseData.terms.map((element, index) => {
                  if (new Date(element.date_from) > new Date()) {
                    return (
                      <Grid item key={index}>
                        <Button
                          onClick={() => onButtonClick(element.date_from)}
                          sx={{
                            backgroundColor: "#7a7cdc",
                            border: "2px sold",
                            borderColor: "#7a7cdc",
                            borderRadius: "22px",
                            paddingRight: "15px",
                            paddingLeft: "15px",
                            "&:hover": {
                              backgroundColor: "#70ccee",
                              color: "white",
                            },
                          }}
                        >
                          {element.date_from === element.date_to ? (
                            <Typography
                              sx={{
                                color: "white",
                                fontFamily: fontType.semiBold,
                                fontSize: "16px",
                              }}
                            >{`${formatDate(element.date_from)}`}</Typography>
                          ) : (
                            <Typography
                              sx={{
                                color: "white",
                                fontFamily: fontType.semiBold,
                                fontSize: "16px",
                              }}
                            >{`${formatDate(element.date_from)} - ${formatDate(element.date_to)}`}</Typography>
                          )}
                        </Button>
                      </Grid>
                    );
                  }
                })
              ) : (
                <Typography
                  sx={{
                    color: "white",
                    fontFamily: fontType.semiBold,
                    fontSize: "22px",
                  }}
                >
                  Termín dohodou
                </Typography>
              )}
            </Grid>
            <MyCalendar terms={courseData?.terms} />
          </Box>
        </Collapse>
      </motion.div>
        {course?.phrase && (
            <motion.div
                ref={third}
                initial={{ opacity: 0, y: 50 }}
                animate={inViewThird ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.7 }}
            >
                <Box
                    sx={{
                        backgroundColor: "#7b7cd5",
                        display: "flex",
                        justifyContent: "center",
                        borderTop: "2px solid",
                        borderColor: "white",
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: "1440px",
                            width: "100%",
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "space-between",
                            flexDirection: { md: "row", xs: "column" },
                            marginTop: "35px",
                            marginBottom: "35px",
                        }}
                    >
                        <Box sx={{ marginLeft: { md: "9vw", xs: "0" } }}>
                            <Typography
                                sx={{
                                    color: "white",
                                    fontFamily: fontType.semiBold,
                                    fontSize: "22px",
                                    lineHeight: "26px",
                                    maxWidth: { md: "500px", xs: "unset" },

                                    textAlign: { md: "start", xs: "center" },
                                    paddingRight: { md: "0", xs: "15px" },
                                    paddingLeft: { md: "0", xs: "15px" },
                                }}
                            >
                                {course?.phrase}
                            </Typography>
                        </Box>
                        {(!course?.showPrice || (courseData?.price && courseData?.terms?.length > 0)) &&
                            (
                                <Button
                                    onClick={() => handleFormOpen()}
                                    sx={{
                                        borderRadius: "28px",
                                        backgroundColor: "#f6961d",
                                        fontFamily: fontType.semiBold,
                                        fontSize: 16,
                                        cursor: "pointer",
                                        color: "white",
                                        height: "44px",
                                        minWidth: "249px",
                                        whiteSpace: "nowrap",
                                        paddingLeft: "20px",
                                        paddingRight: "20px",
                                        textTransform: "initial",
                                        marginTop: { md: "0px", xs: "25px" },
                                        marginRight: { md: "9vw", xs: "10px" },
                                        "&:hover": {
                                            backgroundColor: "#3fcaea",
                                            color: "white",
                                        },
                                    }}
                                >
                                    {course?.btnTxt}
                                </Button>
                            )
                        }

                    </Box>
                </Box>
            </motion.div>
        )}
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.7 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#eba62c",
            borderTop: "2px solid",
            borderColor: 'white'
          }}
        >
          <Box
            sx={{
              maxWidth: "1440px",
              width: "100%",
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
              flexDirection: { md: "row", xs: "column" },
              marginTop: "35px",
              marginBottom: "35px",
            }}
          >
            <Box sx={{ marginLeft: { md: "9vw", xs: "0" } }}>
              <Typography
                sx={{
                  color: "white",
                  fontFamily: fontType.semiBold,
                  fontSize: "22px",
                  lineHeight: "26px",
                  textAlign: { md: "start", xs: "center" },
                  paddingRight: { md: "0", xs: "15px" },
                  paddingLeft: { md: "0", xs: "15px" },
                }}
              >
                Je objednanie školenia cez programy Úradu práce alebo úver príliš komplikované?
              </Typography>
              <Typography
                sx={{
                  color: "white",
                  fontFamily: fontType.semiBold,
                  fontSize: "22px",
                  textAlign: { md: "start", xs: "center" },
                  lineHeight: "26px",
                }}
              >
                Nevadí, pomôžeme ti s tým.
              </Typography>
            </Box>
            <Button
              onClick={() => openForm()}
              sx={{
                borderRadius: "28px",
                backgroundColor: "#7a7cdc",
                fontFamily: fontType.semiBold,
                fontSize: 16,
                cursor: "pointer",
                color: "white",
                height: "44px",
                width: "186px",
                whiteSpace: "nowrap",
                textTransform: "initial",
                marginTop: { md: "0px", xs: "25px" },
                marginRight: { md: "9vw", xs: "20px" },
                "&:hover": {
                  backgroundColor: "#70ccee",
                },
              }}
            >
              Pomôcť vybaviť
            </Button>
          </Box>
        </Box>
      </motion.div>
    </Box>
  );
};

export default Calendar;
